module.exports = __webpack_public_path__ + "img/aboutShengrongAn_5.7b794d0a.png";